var _path, _text;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStudentPrevious(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 27.681,
    viewBox: "0 0 54 27.681",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-970.157,604.94c-3.955-2.271-6.343-5.218-6.343-8.439,0-7.18,11.865-13,26.5-13s26.5,5.82,26.5,13-11.865,13-26.5,13a45.1,45.1,0,0,1-17.508-3.241l-4.814,3.922Z",
    transform: "translate(977 -583)",
    fill: "#fff",
    stroke: "#1a4fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(27 18)",
    fill: "#1a4fff",
    fontSize: 12
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.5,
    y: 0
  }, "\u524D\u56DE"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStudentPrevious);
export default __webpack_public_path__ + "static/media/icon_student_previous.e125d760.svg";
export { ForwardRef as ReactComponent };